





































import { Vue, Component, Prop } from 'vue-property-decorator'
import { NBMessageWarning, NBMessageError } from '@/utils/nBMessage'
import { LoginUser } from '@/api/UserAdmin'
import { Login } from '@/types/UserAdmin'
@Component
export default class LoginMan extends Vue {
  logo: string = require('@/assets/images/logo1.svg');
  form: Login = {
    account: '',
    password: '',
  };
  async handleSubmit() {
    const { form } = this
    const { account, password } = form
    if (account !== '' && password !== '') {
      const { data, code } = await LoginUser(form)
      if (code === 0) {
        localStorage.setItem('user', JSON.stringify(data))
        this.$router.push('/group/list')
      }

      return
    }
    NBMessageWarning(this, { message: '请输入正确的账号密码' })
  }
}
